import styled from 'styled-components';
import TextInput from '../../atoms/TextInput';
import {TextButtonBase} from '../../atoms/TextButton';
import FloatingActionButton from '../../atoms/FloatingActionButton';
import ContainedButton from '../../atoms/ContainedButton';
import TextArea from '../../atoms/TextArea';
import {SaveIcon,TwitterIcon,InfoIcon} from '../../atoms/Icons';

import {
	SurfaceColor, 
	DividerColor,
	Grey400, 
	ErrorColor, 
	ShadowColor, 
	DisableColor,
	AccentColor,
	DarkAccentColor,
	OnAccentColor
} from '../../Colors';

const defaultStyle = {
	Wrapper : styled.div`
		padding : 1rem;
		box-shadow: 0px 8px 16px 0px ${ShadowColor};
        border-radius : 5px;
		background-color : ${SurfaceColor};
		display : flex;
		flex-direction : column;
		&>:last-child{
			margin-top : auto;
		}
	`,
	CaptionLabel : styled.label`
		font-size : 0.5rem;
	`,
	BasicInformation : styled.div`
		display : flex;
	`,
	TextInput : styled(TextInput).attrs({
		borderType : 'underlined'
	})`
		border : none;
		width : 90%;
		&:hover{
			border-color : ${DividerColor};
		}
	`,
	TwitterText : styled(TextInput).attrs({
		borderType : 'none'
	})`
		margin : auto;
		display : block;
		align-self: center;
	`,
	ProfileWrapper : styled.div`
		margin-left : 1rem;
		& > div{
			padding-bottom : 1rem;
		}
	`,
	AvatarWrapper : styled.div`
		padding : 1rem;
	`,
	Avatar : styled.img`
		width : 200px;
		height : 200px;
		border-radius: 1rem;
		cursor : pointer;
    `,
	Information : styled.div`
		margin-top : 1rem;
		& > div{
			padding-bottom : 1rem;
		}
	`,
	ErrorMessage : styled.div`
		color : ${ErrorColor};
	`,
	InfoIcon : styled(InfoIcon)`
		margin-right : 1rem;
	`,
	ComentWrapper : styled.div`
	`,
	UploadDiv : styled.div`
		display : flex;
		align-items : center;
		& > div{
			width : 100%;
			& > input {
				width : 100%;
			}
		}
	`,
	UploadButton : styled(TextButtonBase)`
		color : ${AccentColor};
		&:focus{
			color : ${DarkAccentColor};
		}
		&:hover{
			color : ${DarkAccentColor};
		}
		&:disabled{
			background-color : transparent;
			color : ${DisableColor};
		}
	`,
	TwitterWrapper : styled.div`
		display : flex;
		align-items : center;
		justify-content: center;
		padding : 1rem;
		border-radius : 5px;
		& > label {
			display : block;
			color : ${Grey400};
		}
		&:hover{
			border: 1px solid ${DividerColor};
		}
		&:focus-within{
			border: 1px solid ${DividerColor};
		}
	`,
	TwitterIcon : styled(TwitterIcon)`
		font-size : 2rem;
		margin-right : 0.5rem;
	`,
	SaveButton : styled(FloatingActionButton)`
		padding : 1rem;
	`,
	Comment : styled(TextArea)`
		width : 100%;
		min-height : 20vh;
		background-color : transparent;
		border : none;
		&:hover {
			border: 1px solid ${DividerColor};
		}
	`,
	ActionButtons : styled.div`
		display : flex;
		justify-content : flex-end;
		padding : 1rem;
		font-size : 2rem;
	`,
	SaveIcon : styled(SaveIcon)`
		margin-right : 1rem;
	`
};

const mobileStyle = {
	Wrapper : styled.div`
        width : 100%;
		padding : 1rem;
		background-color : ${SurfaceColor};
	`,
	CaptionLabel : styled.label`
		font-size : 1rem;
	`,
	TextInput : styled(TextInput)`
		width : 100%;
	`,
	AvatarWrapper : styled.div`
		padding-top : 1rem;
		display : flex;
		justify-content : center;
	`,
	Information : styled.div`
		padding : 1rem;
		& > div{
			padding-bottom : 1rem;
		}
	`,
	ActionButtons : styled.div`
		display : flex;
		justify-content : center;
		font-size : 2rem;
	`,
	UploadDiv : styled.div`
		text-align : right;
	`,
	UploadButton : styled(ContainedButton)`
		margin-right : 1rem;
		margin-top  : 1rem;
		color : ${OnAccentColor};
		&:focus{
			color : ${OnAccentColor};
		}
		&:hover{
			color : ${OnAccentColor};
		}
		&:disabled{
			background-color : transparent;
			color : ${DisableColor};
		}
	`,
	TwitterWrapper : styled.div`
		display : flex;
		align-items : center;
		justify-content: center;
		padding : 1rem;
		& > label {
			display : block;
			color : ${Grey400};
		}
	`,
	TwitterText : styled(TextInput).attrs({
		borderType : 'none'
	})`
		padding : 0;
		margin-left : 0.5rem;
		display : block;
		align-self: center;
	`,
	Comment : styled(TextArea)`
		width : 100%;
		min-height : 20vh;
		background-color : transparent;
		border : none;
		padding : 1rem;
		border-radius : 0;
		&:focus {
			border-left: 1px solid ${DividerColor};
		}
	`,
};

export default defaultStyle;
export {mobileStyle};